import React from 'react';

function Contact() {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">Contact Us</h1>
      </div>

      <div className="page-body">
        <p>
          We'd love to hear from you! Whether you have questions, suggestions, or topics you'd like us to cover,
          feel free to reach out.
        </p>

        <h2>Get In Touch</h2>

        <h3>Social Media</h3>
        <p>
          Follow us on social media for daily tips, updates, and community discussions:
        </p>
        <ul>
          <li><strong>Instagram:</strong> <a href="https://www.instagram.com/howtobachelor/" target="_blank" rel="noopener noreferrer">@howtobachelor</a></li>
          <li><strong>Twitter:</strong> <a href="https://twitter.com/HowToBachelor" target="_blank" rel="noopener noreferrer">@HowToBachelor</a></li>
          <li><strong>YouTube:</strong> <a href="https://www.youtube.com/channel/UC3brbCy2-6pQnkdgS0aZlsQ" target="_blank" rel="noopener noreferrer">How To Bachelor Channel</a></li>
        </ul>

        <h3>Email</h3>
        <p>
          For business inquiries, partnerships, or general questions, email us at:
          <br />
          <strong>contact@howtobachelor.com</strong>
        </p>

        <h2>Content Suggestions</h2>
        <p>
          Have a topic you'd like us to cover? We're always looking for new ideas and ways to help our community.
          Send us your suggestions and we'll do our best to create content that addresses your needs.
        </p>

        <h2>Partnerships</h2>
        <p>
          Interested in partnering with How To Bachelor? We're open to collaborations that align with our mission
          of helping bachelors live their best lives. Reach out via email to discuss opportunities.
        </p>
      </div>
    </div>
  );
}

export default Contact;
